module.exports = __webpack_public_path__ + "img/bc9ec73.svg";